import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=7d1fc60c&scoped=true&"
import script from "./ContactCard.vue?vue&type=script&lang=js&"
export * from "./ContactCard.vue?vue&type=script&lang=js&"
import style0 from "./ContactCard.vue?vue&type=style&index=0&id=7d1fc60c&lang=scss&scoped=true&"
import style1 from "./ContactCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1fc60c",
  null
  
)

export default component.exports